var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-5"},[_c('div',{staticClass:"py-5"},[_c('Rescues',{attrs:{"num_results":"4","title":"Védenceink","show_more":"false","status":"DECEASED"}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }